<div class="rounded bg-light p-2">
  <h5 class="mb-0">
    <i class="fa fa-user"></i> {{ utente?.nomeCompleto }} - {{ operatore?.codice }}
  </h5>
</div>

